enum Role {
  Trainee = 100,
  Fellow = 200,
  CollegeAdmin = 800,
  SystemAdmin = 900,
  BasicTrainee = 110,
  HigherTrainee = 120,
  GeneralFellow = 210,
  Trainer = 220,
  COS = 400,
  Supervisor = 300,
  SecretaryBoardExaminers = 240,
  ChairpersonBoardExaminers = 250
}

enum BasicRole {
  Trainee = 100,
  CosSupervisor = 300,
  CollegeAdmin = 800,
  SystemAdmin = 900
}

enum SystemRole {
  BasicTrainee_BST = 110,
  HigherTrainee_HOT = 120,
  Supervisor = 310,
  COS = 320
}

enum SystemParameterId {
  'System email address' = 1,
  'No. of login attempt' = 2,
  'Password minimum length (1- 10)' = 3,
  'Password maximum length (1- 99)' = 4,
  'Number of password history kept (0 - 10)' = 5,
  'No. of days of password validity (0 to 999): 0 is no expiration' = 6,
  'Password complexity - Upper case (Yes / No)' = 7,
  'Password complexity - Lower case (Yes / No)' = 8,
  'Password complexity - Special character (Yes / No)' = 9,
  'Password complexity - Accepted special character (!, @, #, $, %, ^, &, *)' = 10,
  'Allowed Upload File Format' = 11,
  'Max Upload File Size Allowed (MB)' = 12,
  'Basic training annual checking start date' = 13,
  'Supervisor declaration start date' = 14,
  'Rotation - Invitation of Providing the supervisor information - No. of days before the end of rotation' = 15,
  'Rotation - Invitation of Providing the next rotation - No. of days before the end of current rotation' = 16,
  'Rotation - Invitation of end of rotation assessment form submission for the basic training - No. of days before the rotation end date' = 17,
  'Rotation - Reminder of rotation feedback form submission for the basic training - No. of days before the rotation end date' = 18,
  'Enable online payment' = 19,
  'Basic Training Application Fee' = 20,
  'Basic Training Completion Application Fee' = 21,
  'Admin Fee' = 22
}

enum RoleType {
  BasicRole = 0,
  SystemRole = 1
}

enum TrainingType {
  BasicTraining = 1,
  HigherTraining = 2,
  Both = 3
}

enum ParameterType {
  String = 1,
  Integer = 2,
  Decimal = 3,
  Datetime = 4,
  Boolean = 5
}

enum PaymentMethod {
  Online = 1,
  Cheque = 2,
  BankTransfer = 3
}

enum PaymentStatus {
  Unpaid = 0,
  Settled = 1,
  PendingOnlinePayment = 2
}

enum PaypalCaptureStatus {
  Completed = 0,
  Declined = 1,
  PartiallyRefunded = 2,
  Pending = 3,
  Refunded = 4,
  Failed = 5
}

enum FormType {
  'Feedback on Hospital-based Training' = 1,
  'Feedback on Community-based Training' = 2,
  'Community Assessment Form' = 3,
  'Basic Training Logbook Checking' = 4,
  'Basic Training Completion Form' = 5,
  'Hospital Assessment Form' = 6
}

enum FormTypeId {
  BasicApplicationForm = 1
}

enum DocumentType {
  HKID = 1,
  MBBSDiploma = 2,
  MCHKRegistrationLicense = 3,
  JuniorTraineeAppointmentLetter = 4,
  SeniorTraineeAppointmentLetter = 5,
  VeriGuideReportForPlagiarismDetection = 6,
  PartIIIDissertationForAssessment = 7,
  EthicsApprovalDocument = 8
}

enum AssessmentFormType {
  InterimAssessmentTrainer = 1,
  EndOfIndividualRotationAssessmentTrainer = 2,
  HigherEndOfIndividualRotationAssessmentTrainer = 3,
  CasebookAssessment = 4,
  ClinicalModuleTraineeEvaluationForm = 5,
  ClinicalModuleTrainerEvaluationForm = 6,
  LectureModuleTraineeEvaluationForm = 7,
  LecureModuleSpeakerEvaluationForm = 8,
  LogbookAssessmentForBasicTraining = 9,
  LogbookAssessmentForHigherTraining = 10
}

enum OptionMode {
  Rating1 = 1,
  Rating2 = 2,
  YesNo11 = 11,
  YesNo12 = 12,
  YesNo13 = 13,
  Comment = 21,
  InputNumber = 22
}

enum OptionModeYesNo {
  Yes = 1,
  No = 0,
  Na = 2
}

enum RatingValue {
  zero = 0,
  one = 1,
  two = 2,
  three = 3,
  four = 4,
  five = 5
}
enum RatingValue21 {
  one = 1,
  tow = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 11
}
enum RatingValue31 {
  StronglyDisagree = 1,
  Disagree = 2,
  Agree = 3,
  StronglyAgree = 4
}

enum QuestionaireFormType {
  BasicTraining = 1,
  HigherTraining = 2
}

enum QuestionaireOptionMode {
  'N/A' = 0,
  'Integer(1-999)' = 1,
  'Integer(1-100)' = 2,
  'Yes / No (Yes, No)' = 11,
  'Rating(1-6)' = 21,
  'Rating (Strongly disagree, Disagree, Neutral, Agree, Strongly agree)' = 22,
  'Rating (1-6) With Other' = 23,
  'Comment' = 41,
  'In firm meeting = 1, During OPD session = 2, Both' = 51,
  'Far too few, Too few, Appropriate, Too much, Far too much' = 61
}

enum QuestionLevel {
  Level1 = 1,
  Level2 = 2,
  Level3 = 3
}

enum QuestionaireRating21 {
  one = 1,
  two = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 6
}

enum QuestionaireRating22 {
  'Strongly disagree' = 1,
  'Disagree' = 2,
  'Neutral' = 3,
  'Agree' = 4,
  'Strongly agree' = 5
}

enum QuestionaireRating51 {
  'In firm meeting' = 1,
  'During OPD session' = 2,
  'Both' = 3
}

enum QuestionaireRating61 {
  'Far too few' = 1,
  'Too few' = 2,
  'Appropriate' = 3,
  'Too much' = 4,
  'Far too much' = 5
}

export const systemEnums = {
  Role,
  BasicRole,
  SystemRole,
  RoleType,
  TrainingType,
  ParameterType,
  FormType,
  DocumentType,
  PaymentMethod,
  PaymentStatus,
  PaypalCaptureStatus,
  SystemParameterId,
  AssessmentFormType,
  OptionMode,
  RatingValue,
  RatingValue21,
  RatingValue31,
  QuestionaireFormType,
  QuestionaireOptionMode,
  QuestionLevel,
  QuestionaireRating21,
  QuestionaireRating22,
  QuestionaireRating51,
  QuestionaireRating61,
  OptionModeYesNo,
  FormTypeId
}
